(function ($) {

    $(document).ready(function () {

        function getTalkToExpertScrollTop() {
            var headerOffset = $('#seller-splash-header').outerHeight() || 0;

            return $talkToExpertSection.offset().top - headerOffset + 1;
        }

        function animatePageTo(scrollTop, duration) {
            $('html, body').stop(true, false).animate({
                scrollTop: Math.max(scrollTop, 0)
            }, duration);
        }

        $('a[href^="#"]').on('click', function (event) {
            var href = this.getAttribute('href');
            // Placeholder links such as the country prompt do not identify a scroll target
            if (href === "#") {
                return;
            }

            if (href === "#talk-to-an-expert" || href === "#talk-to-expert") {
                event.preventDefault();
                showTalkToExpert($(this).data("talk-to-expert-target") || "expert", true);
                return;
            }

            var target = $(href);
            if (target.length) {
                event.preventDefault();
                var scrollTop = target.offset().top + 1;

                animatePageTo(scrollTop, 1000);
            }
        });

        function initialisePartnerSlider() {
            $('#newPartnerIcons').bxSlider({
                minSlides: 1,
                maxSlides: 5,
                slideWidth: 250,
                slideMargin: 10,
                ticker: true,
                speed: 300000
            });
        }

        // jQuery 3 can run document-ready handlers after the window load event
        if (document.readyState === 'complete') {
            initialisePartnerSlider();
        } else {
            $(window).one('load', initialisePartnerSlider);
        }

        // Keep the dialling code badge aligned with the selected option.
        var $talkToExpertDialCodes = $('[data-talk-to-expert-dial-code]');
        var $talkToExpertForms = $('[data-talk-to-expert-form]');

        $talkToExpertDialCodes.on("change", function () {
            $(this)
                .closest('[data-talk-to-expert-dial-code-wrap]')
                .find('[data-talk-to-expert-dial-code-placeholder]')
                .text($(this).val());
        });

        // Submit the Talk To An Expert form via AJAX and show the response inline.
        $talkToExpertForms.on("submit", function (event) {
            event.preventDefault();

            var $form = $(this);
            if ($form.data("submitted") || !$form.valid()) {
                return;
            }
            var $status = $form.find('[data-talk-to-expert-status]');
            var $submit = $form.find("button[type='submit']");

            $status.removeAttr("data-status").text("Sending...");
            $submit.prop("disabled", true);

            $.ajax({
                url: $form.attr("action"),
                type: "POST",
                data: $form.serialize()
            }).done(function (response) {
                if (response && response.success) {
                    $form.data("submitted", true);
                    $form.find(":input, button").prop("disabled", true);

                    var $success = $form.closest('[data-talk-to-expert-container]').find('[data-talk-to-expert-success]');
                    if ($success.length) {
                        $form.hide();
                        $success.show();
                    } else {
                        $status.attr("data-status", "success").text(response.message || "Message sent.");
                    }
                } else {
                    if (response && response.errors) {
                        $form.validate().showErrors(response.errors);
                        $status.removeAttr("data-status").text("");
                    } else {
                        var errorMessage = response && response.message ? response.message : "Something went wrong. Please try again.";
                        $status.attr("data-status", "error").text(errorMessage);
                    }
                }
            }).fail(function () {
                $status.attr("data-status", "error").text("Something went wrong. Please try again.");
            }).always(function () {
                if (!$form.data("submitted")) {
                    $submit.prop("disabled", false);
                }
            });
        });

        // Toggle the pricing vs Talk To An Expert tabs.
        var $talkToExpertTabs = $('[data-talk-to-expert-tab]');
        var $talkToExpertPanels = $('[data-talk-to-expert-panel]');
        var $talkToExpertHideSections = $('[data-talk-to-expert-hide]');
        var $talkToExpertNav = $('[data-talk-to-expert-nav]');
        var $talkToExpertCta = $('[data-talk-to-expert-cta]');
        var $talkToExpertSection = $('#talk-to-an-expert');

        function setTalkToExpertVisibility($elements, shouldHide) {
            if (!$elements.length) {
                return;
            }
            if (shouldHide) {
                $elements.attr("hidden", "hidden").attr("aria-hidden", "true").css("display", "none");
            } else {
                $elements.removeAttr("hidden").removeAttr("aria-hidden").css("display", "");
            }
        }

        function updateTalkToExpertSections(target) {
            var isExpert = target === "expert";
            var shouldHideLowerSections = isExpert && !isTalkToExpertMobileLayout();
            // Hide lower sections and the header nav when the CA "Talk To An Expert" tab is active.
            setTalkToExpertVisibility($talkToExpertHideSections, shouldHideLowerSections);
            setTalkToExpertVisibility($talkToExpertNav, isExpert);
            setTalkToExpertVisibility($talkToExpertCta, !isExpert);
        }

        function isTalkToExpertMobileLayout() {
            return window.matchMedia && window.matchMedia("(max-width: 64em)").matches;
        }

        function selectTalkToExpertTab(target) {
            var $tab = $talkToExpertTabs.filter('[data-tab-target="' + target + '"]');
            if (!$tab.length) {
                return false;
            }

            $('html, body').stop(true, false);
            $talkToExpertTabs.removeClass("is-active").attr("aria-selected", "false");
            $tab.addClass("is-active").attr("aria-selected", "true");

            $talkToExpertPanels.removeClass("is-active").attr("hidden", "hidden");
            $talkToExpertPanels.filter('[data-talk-to-expert-panel="' + target + '"]').addClass("is-active").removeAttr("hidden");
            updateTalkToExpertSections(target);
            return true;
        }

        function showTalkToExpert(target, animate) {
            if (!selectTalkToExpertTab(target) || !$talkToExpertSection.length) {
                return;
            }

            var scrollTop = $talkToExpertSection.offset().top + 1;
            if (isTalkToExpertMobileLayout()) {
                scrollTop = getTalkToExpertScrollTop();
            }
            animatePageTo(scrollTop, animate ? 1000 : 0);
        }

        if ($talkToExpertTabs.length) {
            $talkToExpertTabs.on("click", function () {
                selectTalkToExpertTab($(this).data("tab-target"));
            });

            var initialTarget = $talkToExpertTabs.filter(".is-active").data("tab-target") || "pricing";
            updateTalkToExpertSections(initialTarget);

            if (window.location.hash === "#talk-to-an-expert" || window.location.hash === "#talk-to-expert") {
                window.setTimeout(function () {
                    showTalkToExpert("expert", false);
                }, 0);
            }
        }
        $(window).scroll(function () {
            var position = window.pageYOffset;
            $('.section').each(function () {
                var target2 = $(this).offset().top - 10;
                var id = $(this).attr('id');

                var navLinks = $('.sell-splash-nav li');
                if (position >= target2) {
                    navLinks.removeClass('selected');
                    $('.sell-splash-nav li a[href="#' + id + '"]').parent().addClass('selected');
                }
            });
            if (jQuery(this).scrollTop() !== 0) {
                jQuery('#seller-splash-header').addClass("sticky-head");

            } else {
                jQuery('#seller-splash-header').removeClass("sticky-head");
                jQuery('.sell-splash-nav li').removeClass("selected");
            }
        });

        // Number animation logic
        const animateNumbers = () => {
            const numbers = $('.number'); // Select all numbers with class 'number'

            numbers.each(function () {
                const $this = $(this);
                const target = +$this.data('count'); // Get the final target number
                let current = 0;
                const step = Math.ceil(target / 100);

                // Function to increment the number
                const increment = () => {
                    current += step;
                    if (current >= target) {
                        $this.text(target.toLocaleString());
                    } else {
                        $this.text(current.toLocaleString());
                        requestAnimationFrame(increment);
                    }
                };

                increment();
            });
        };

        // Trigger number animation when document is ready
        animateNumbers();

    });

})(jQuery);